"use strict";

exports.__esModule = true;
exports.UNASSIGNED = exports.TICKET_PRIORITIES = exports.DEFAULT_ACTIONS = exports.ACTION_TYPES = void 0;
var UNASSIGNED = exports.UNASSIGNED = "Unassigned";
var TICKET_PRIORITIES = exports.TICKET_PRIORITIES = [{
  id: "Low",
  color: "rgb(0, 156, 224)"
}, {
  id: "Medium",
  color: "rgb(104, 188, 0)"
}, {
  id: "High",
  color: "rgb(217, 94, 0)"
}, {
  id: "Critical",
  color: "rgb(211, 49, 21)"
}];
var ACTION_TYPES = exports.ACTION_TYPES = [{
  id: "ON_CREATE",
  label: "On Create"
}, {
  id: "ON_UPDATE",
  label: "On Update"
}, {
  id: "ON_COMMENT",
  label: "On Comment"
}, {
  id: "ON_CLOSE",
  label: "On Close"
}];
var DEFAULT_ACTIONS = exports.DEFAULT_ACTIONS = ACTION_TYPES.map(function (action) {
  return action.id;
});